<template>
  <div class="row">
    <div class="col-md-12 p-t-20">
      <h5 class="h5">
        <i class="fe fe-activity"></i>Enrollee Data by LGA and Facility
      </h5>
    </div>

    <div class="col-md-12">
      <div class="card m-b-30">
        <div class="card-header">
          <button class="btn btn-outline-primary spacer" @click="getBasic">
            BHCPF
          </button>
          <button class="btn btn-outline-primary spacer" @click="getSEP">
            PHI
          </button>

           <button
              type="button"
              class="btn btn-outline-success ml-4"
              @click="getChart('UNICEF')"
            >
              UNICEF
            </button>

             <button
              type="button"
              class="btn btn-outline-success ml-4"
              @click="getChart('GAVI')"
            >
              GAVI
            </button>


        </div>

        <div class="card-body">
          <highcharts :options="chartOptions"></highcharts>
          <p class="text-primary" v-show="isLoading">Chart Loading...</p>
        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      title: "",
      sector: "Basic Healthcare Provision Fund",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
      getChart(param) {
      this.isLoading = true;
      this.sector = param;
      this.getDashboardLGA();
      this.isLoading = false;
    },
    
    getDashboardLGA() {
      this.isLoading = true;
      this.axios
        .get("/api/v1/auth/EnrolleeDashboardProviderData/2683", {
          params: {
            sector: this.sector,
          },
        })
        .then((response) => {
          // console.log(response.data);
          var data = response.data;
          this.isLoading = false;

          console.log(data[0].wards);
          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: `Enrollee Distribution Chart For ${this.sector}`,
            },
            subtitle: {
              text: "Click the columns to view the breakdown in the local government based on facility.",
            },
            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            yAxis: {
              title: {
                text: "NUMBER OF ENROLLEES",
              },
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  // format: '{point.y:.1f}'
                },
              },
            },

            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
            },

            series: [data[0].lga],
            drilldown: {
              series: data[0].facilities,
            },
          };
        });
    },

    getBasic() {
      this.sector = "Basic Healthcare Provision Fund";
      this.getDashboardLGA();
    },
    getSEP() {
      this.sector = "Pro Health International";
      this.getDashboardLGA();
    },
  },
};
</script>

<style></style>
